import React, { Component, PropTypes as pt } from 'react';

import TextInput from '../../hoc/types/TextInput';
import withStateUtils from '../../hoc/PreferenceStateUtil';

import Navigation from '../../lib/Navigation';
import EditorTabWrapper from '../../lib/PreferenceTabWrapper';

const validateAndStoreEdits = (preferenceName, newValue, preferences, tab, storeEdits) => {
    // console.log('tab:', preferenceName, newValue, preferences, tab, storeEdits)
    if (preferenceName === 'filterControl' && newValue === false) {
        // when the filter control is disabled all other filter controls should be disabled as well
        Object.keys(preferences).forEach(prefName => {
            storeEdits(prefName, false)
        })
    } else if (tab === 'filtering' && preferenceName !== 'filterControl') {
        // if a filter is enabled while filter control is disabled, enable filter control
        storeEdits('filterControl', true)
        storeEdits(preferenceName, newValue)
    } else if (tab === 'layout' && preferenceName === 'configLayout' && newValue === 'table') {
        // if the table layout is chosen disable show thumbnails
        storeEdits('images', false)
        storeEdits(preferenceName, newValue)
    } else {
        storeEdits(preferenceName, newValue)
    }
}

class ListingPreferenceEditor extends Component {
    constructor (props) {
        super(props);

        this.state = {
            nav: {
                name: 'Layout',
                key: 'layout'
            }
        };

        this.toggleActiveTab = this.toggleActiveTab.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
    }

    toggleActiveTab (item) {
        this.setState({
            nav: item
        });
    }

    handleChange (preferenceName, value) {
        // console.log('preferences', this.props.preference)
        const storeEdits = (preferenceName, value) => this.props.stateUtils.storeEdits(preferenceName, value)
        validateAndStoreEdits(preferenceName, value, this.props.preference[this.state.nav.key].preferences, this.state.nav.key, storeEdits)
    }

    render () {
        // console.log(this.props);
        
        return (<div>
            <header className="row">
                {this.renderHeader()}
            </header>

            <br/>

            <div className="row" id="listing-preference-editor">
                <div className="col-md-2">
                    <Navigation
                        {...this.props}
                        nav={this.state.nav}
                        toggleActiveTab={this.toggleActiveTab}/>
                </div>
                <div className="col-md-10">
                    <EditorTabWrapper
                        {...this.props}
                        handleChange={this.handleChange}
                        activeTab={this.state.nav.key}/>
                </div>
            </div>
        </div>);
    }

    renderHeader () {
        return (<div className="col-sm-12">
            <div className="callout">
                <div className="col-md-6">
                    <div className="input-group">
                        <span className="input-group-addon">
                            Preference Title
                        </span>
                        <TextInput
                            placeholder="Required"
                            value={this.props.preference.name}
                            storeEdits={this.props.stateUtils.storeEdits.bind(null, 'name')}
                        />
                    </div>
                </div>
                <div className="col-md-6 text-right">
                    <button type="button"
                        disabled={Object.keys(this.props.edits).length === 0}
                        onClick={this.props.stateUtils.undoEdits}
                        className="btn btn-link">
                        Reset
                    </button>
                    <button type="button"
                        disabled={Object.keys(this.props.edits).length === 0}
                        onClick={this.props.stateUtils.commitEdits}
                        className="btn btn-primary">
                            <i className="fa fa-save"/>
                            &nbsp;{this.props.preferenceID ? 'Save' : 'Create'}
                    </button>
                </div>
            </div>
        </div>);
    }
}

ListingPreferenceEditor.propTypes = {};

var WrapperWithState = withStateUtils(
    ListingPreferenceEditor
);

export default WrapperWithState;
